module.exports = __webpack_public_path__ + "img/vip-icon.170e5ae3.png";